<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Liens utiles</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_liens_utiles.PNG" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <ul class="ms-5">
                <li><a target="_blank" href="https://fr.wikipedia.org/wiki/{{ favorite.ad_city.name}}">Wikipédia</a></li>
                <li><a target="_blank" href="http://www.linternaute.com/ville/{{ favorite.ad_city.slug }}/ville-{{ favorite.ad_city.city_code }}">L'internaute ville</a></li>
                <li><a target="_blank" href="https://immobilier.statistiques.notaires.fr/prix-immobilier?typeLocalisation=COMMUNE&codeInsee={{ favorite.ad_city.city_code }}">Immobilier notaire</a></li>
                <li><a target="_blank" href="https://france-decouverte.geoclip.fr/#c=indicator&selcodgeo={{ favorite.ad_city.city_code}}">France découverte Géoclip</a></li>
            </ul>
        </div>
    </div>
</div>
